interface DefaultValue {
  value?: string;
  variableName?: string;
}

export const parseDefaultValue = (
  fieldDefaultValue?: string
): DefaultValue | null => {
  if (!fieldDefaultValue) return null;

  const isNumber = !isNaN(+fieldDefaultValue);
  if (isNumber) return { value: fieldDefaultValue, variableName: undefined };

  const isSingleVariableName = !fieldDefaultValue.includes("||");
  if (isSingleVariableName)
    return { value: undefined, variableName: fieldDefaultValue };

  const [variableName, value] = fieldDefaultValue.split("||");
  if (!variableName || !value) return null;

  return {
    variableName: variableName.trim(),
    value: value.trim(),
  };
};
